import { createTheme } from "@mui/material/styles";
import type { BrandTokens } from "../types";

export const createNocturneTheme = (brand: BrandTokens) =>
  createTheme({
    palette: {
      mode: "dark",
      primary: { main: "#6b4eff" },
      secondary: { main: "#9aa0b4" },
      warning: { main: "#f2b705" },
      background: { default: "#0b0d10", paper: "#151922" },
      text: { primary: "#e7e9f2", secondary: "rgba(231, 233, 242, 0.68)" }
    },
    shape: { borderRadius: brand.radius + 2 },
    typography: {
      fontFamily: "\"Space Grotesk\", \"Segoe UI\", sans-serif",
      h1: { fontWeight: 600, letterSpacing: "-0.02em", fontSize: "clamp(2.4rem, 4vw, 3.4rem)" },
      h2: { fontWeight: 600, letterSpacing: "-0.015em", fontSize: "clamp(1.9rem, 3.2vw, 2.6rem)" },
      h3: { fontWeight: 600, fontSize: "clamp(1.4rem, 2.4vw, 2rem)" },
      body1: { fontSize: "1rem", lineHeight: 1.7 },
      body2: { fontSize: "0.95rem", lineHeight: 1.7 },
      button: { textTransform: "none", fontWeight: 600, letterSpacing: "0.01em" }
    },
    components: {
      MuiCssBaseline: {
        styleOverrides: {
          ":root": {
            "--app-bg": "#0b0d10",
            "--app-surface": "#151922",
            "--app-primary": "#6b4eff",
            "--app-accent": "#f2b705"
          },
          body: {
            backgroundColor: "#0b0d10",
            backgroundImage:
              "radial-gradient(900px 420px at 12% -10%, rgba(107, 78, 255, 0.18), transparent 60%)," +
              "radial-gradient(720px 360px at 90% 0%, rgba(242, 183, 5, 0.12), transparent 55%)," +
              "linear-gradient(180deg, #0b0d10 0%, #111720 60%, #0b0d10 100%)",
            color: "#e7e9f2"
          },
          "#root": {
            minHeight: "100vh",
            animation: "fadeRise 420ms ease-out"
          },
          "@keyframes fadeRise": {
            from: { opacity: 0, transform: "translateY(6px)" },
            to: { opacity: 1, transform: "translateY(0)" }
          }
        }
      },
      MuiAppBar: {
        defaultProps: { color: "transparent", elevation: 0 }
      },
      MuiPaper: {
        styleOverrides: { root: { backgroundImage: "none" } }
      },
      MuiButton: {
        styleOverrides: {
          root: { borderRadius: brand.radius + 2, padding: "10px 20px" },
          contained: ({ theme }) => ({
            backgroundColor: "transparent",
            border: `1px solid ${theme.palette.primary.main}`,
            color: theme.palette.primary.main,
            boxShadow: "none",
            "&:hover": {
              backgroundColor: "rgba(107, 78, 255, 0.12)",
              boxShadow: "none"
            }
          })
        }
      },
      MuiCard: {
        styleOverrides: {
          root: { borderRadius: brand.radius + 6, boxShadow: "0 18px 40px rgba(6, 8, 14, 0.5)" }
        }
      },
      MuiLink: {
        styleOverrides: { root: { textDecoration: "none", fontWeight: 500 } }
      }
    }
  });
